// extracted by mini-css-extract-plugin
export default {"group":"dashboardDatesGroup_group__Yhbfg"};